import React from "react";
import { useSearchedDiseases } from "../../../../hooks/disease_knowledge/useSearchedDiseases";
import { ResultCount } from "./ResultCount";
import { SearchResultListItem } from "./SearchResultListItem";

export const SearchResultList = React.memo(function SearchResultList() {
    const { resultList } = useSearchedDiseases();

    return (
        <div className={"search_result"}>
            <ResultCount />
            <ul className={"diseases"}>
                {resultList.length ? (
                    <>
                        {resultList.map(searchedDisease => (
                            <SearchResultListItem key={searchedDisease.id} searchedDisease={searchedDisease} />
                        ))}
                    </>
                ) : (
                    <div className={"noneDiseases"}>
                        該当する医療知識が0件でした。
                    </div>
                )}
            </ul>
        </div>
    );
});
